// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.haYuYOHUilStgK {
  position: relative;
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
  text-align: center;
}
.haYuYOHUilStgK .Ev3q1z6cMjwDpX {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 18px;
  margin-bottom: var(--ds-space-0, 0);
}
.haYuYOHUilStgK .mZGRlVi5SbnTo8 {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
.haYuYOHUilStgK .Z2oYGZn9us2kO7 {
  margin-bottom: var(--ds-space-200, 16px);
}
.haYuYOHUilStgK .Z2oYGZn9us2kO7 .F3dz5lAkYHMMhc {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.haYuYOHUilStgK .Z2oYGZn9us2kO7 ._GOdmnsoILP5CY,
.haYuYOHUilStgK .Z2oYGZn9us2kO7 .dSIo8alBI45Adi {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.haYuYOHUilStgK .hN0yQ_u94oofWF {
  margin-bottom: var(--ds-space-200, 16px);
}
.haYuYOHUilStgK .hN0yQ_u94oofWF .uTMCZXpLG0oW9N {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.haYuYOHUilStgK .UGfpqksUSmEdk_ {
  display: grid;
  height: 70px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-0, 0) 15px;
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
.haYuYOHUilStgK .UGfpqksUSmEdk_ p {
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 450px) {
  .haYuYOHUilStgK {
    width: 265px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCard": `haYuYOHUilStgK`,
	"name": `Ev3q1z6cMjwDpX`,
	"info": `mZGRlVi5SbnTo8`,
	"priceContainer": `Z2oYGZn9us2kO7`,
	"price": `F3dz5lAkYHMMhc`,
	"frequency": `_GOdmnsoILP5CY`,
	"pricingVaries": `dSIo8alBI45Adi`,
	"ctaContainer": `hN0yQ_u94oofWF`,
	"currentPlan": `uTMCZXpLG0oW9N`,
	"enterpriseFooter": `UGfpqksUSmEdk_`
};
export default ___CSS_LOADER_EXPORT___;
